module.exports = __webpack_public_path__ + "static/media/viagra.0246ba50.jpg";